import React from 'react'
import styles from './checklist-container.module.css'

export const Container = ({ children }) => {
    return (
        <div className={styles.container}>
            {Array.isArray(children)
                ? children.map((element, index) => (
                      <div key={`checklist-item-no-${index}`} className={styles['item-container']}>
                          {element}
                      </div>
                  ))
                : children}
        </div>
    )
}
